import React, {Component} from 'react';
import AppNavigation from './AppNavigation';
import AppFooter from './AppFooter';
import SubGroupDetails from './Subcomponents/GroupDetails';
import withRouter from './Functions/WithRouter';

class GroupDetails extends Component {
    constructor(props) {
      super(props)

      this.state = {
      }

      this.loadWorkspace = this.loadWorkspace.bind(this)
    }

    componentDidMount(){
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";
      console.log('opportunity mounted')

      let { groupId } = this.props.params

      let email = localStorage.getItem('email');
      const orgLogo = localStorage.getItem('orgLogo');

      if (!this.props.location.state) {
        console.log('went directly to posting')

        this.setState({ groupId, orgLogo })

      } else {

        const { selectedGroup, objectId } = this.props.location.state;
        console.log('show location state: ', this.props.location.state)

        if (objectId) {
          groupId = objectId
        }

        this.setState({ groupId, selectedGroup, orgLogo })

      }
    }

    componentDidUpdate(prevProps) {
        console.log('componentDidUpdate called within parentGroupDetails ', this.props, prevProps)

      if (this.props.params && this.props.params.groupId !== prevProps.params.groupId) {
        // console.log('new group selected in parent', this.props.params.groupId)
        let selectedGroup = this.props.location.state
        if (this.props.location && this.props.location.state && this.props.location.state.selectedGroup) {
          selectedGroup = this.props.location.state.selectedGroup
        }
        this.setState({ groupId: this.props.params.groupId, selectedGroup })
      }
    }

    loadWorkspace(activeOrg) {
      console.log('loadWorkspace called', activeOrg)

      this.setState({ activeOrg })

    }

    render() {

      return (
        <div>
          <AppNavigation username={this.state.username} activeOrg={this.state.activeOrg} loadWorkspace={this.loadWorkspace}  history={this.props.navigate}/>

          <div>
            <SubGroupDetails selectedGroup={this.state.selectedGroup} groupId={this.state.groupId} history={this.props.navigate} />
          </div>

          {(this.state.activeOrg) && (
            <div>
              {AppFooter(this.props.navigate,this.state.activeOrg,this.state.orgLogo)}
            </div>
          )}
        </div>
      )
    }
}

export default withRouter(GroupDetails)
